import React from 'react'
import { useTheme } from '@/hooks/useTheme'
import { BaseView, BaseText } from '@/components/base'
import { AppIcons } from '@/components/AppIcons'
import { ReasonItemProps } from './types'

export const ReasonItem: React.FC<ReasonItemProps> = ({
  title,
  isChecked,
  onPress,
  isFirstItem,
  isLastItem,
  haveOnlyOneItem,
}) => {
  const theme = useTheme()

  const getBorderRadius = () => {
    if (haveOnlyOneItem) return '12px'
    if (isFirstItem) return '32px 32px 0 0'
    if (isLastItem) return '0 0 32px 32px'
    return '0'
  }

  const getBorderBottom = () => {
    // Используем черный цвет для разделительных полос, как в React Native
    const borderColor = '#000000'
    // Добавляем нижнюю границу для всех элементов кроме последнего
    if (!isLastItem && !haveOnlyOneItem) {
      return `1px solid ${borderColor}`
    }
    return 'none'
  }

  return (
    <BaseView
      row
      align="center"
      justify="space-between"
      px={12}
      py={18}
      style={{
        backgroundColor: theme.colors.background.cardItemRoot,
        borderRadius: getBorderRadius(),
        borderBottom: getBorderBottom(),
        cursor: 'pointer',
      }}
      onClick={onPress}
    >
      <BaseView flex={1}>
        <BaseText fontSize={18} fontFamily="semibold" color="#F3F3F3">
          {title}
        </BaseText>
      </BaseView>

      <BaseView
        style={{
          width: '24px',
          height: '24px',
          borderRadius: '8px',
          background: isChecked
            ? `linear-gradient(135deg, ${theme.colors.background.buttonPrimaryGradient1} 0%, ${theme.colors.background.buttonPrimaryGradient2} 100%)`
            : 'transparent',
          border: isChecked
            ? 'none'
            : `1.7px solid ${theme.colors.icon.disabled}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {isChecked && (
          <AppIcons name="check" size={24} color="icon.activeInputIcon" />
        )}
      </BaseView>
    </BaseView>
  )
}
